import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
  concat,
} from '@apollo/client';

// get token here

const authMiddleware = new ApolloLink(async (operation, forward) => {
  const serviceToken = localStorage.getItem('serviceToken'); ///
  operation.setContext({
    headers: {
      Authorization: `Bearer ${serviceToken}`,
      platform: 'web',
    },
  });
  return forward(operation);
});

const httpLink = new HttpLink({
  uri: () => {
    const endpoint = `${process.env.REACT_APP_BASE_URL}/graphql`;
    return endpoint;
  },
});

const ApolloClientHexaService = new ApolloClient({
  cache: new InMemoryCache(),
  link: concat(authMiddleware, httpLink),
});

export default ApolloClientHexaService;
